document.querySelectorAll('[data-mode]').forEach(cta => {
	cta.addEventListener('click', () => {
		if (cta.classList.contains('active')) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		} else {
			document.querySelector('[data-mode].active')?.classList.remove('active');
			cta.classList.add('active');

			document.querySelectorAll('[data-mode-type]').forEach(mode => {
				if (mode.dataset.modeType === cta.dataset.mode) {
					mode.hidden = false;
				} else {
					mode.hidden = true;
				}
			});
		}
	});
});
